import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Paragraph } from '@vwfs-bronson/bronson-react';

interface NoVehiclesErrorModalProps {
  visible: boolean;
  onCancel: (val?) => void;
  jatoId?: string | null;
}

export const NoVehiclesErrorModal: FunctionComponent<NoVehiclesErrorModalProps> = (props) => {
  const { visible, onCancel, jatoId } = props;
  const { t } = useTranslation();

  return (
    <Modal
      id="NoVehiclesErrorModal"
      hideTitle
      title={t('noVehiclesErrorModal:title')}
      buttonCancelText={t('noVehiclesErrorModal:closeButton')}
      onCancel={() => onCancel()}
      onClose={() => onCancel()}
      shown={visible}
      asPortal
      stretch
    >
      <Paragraph> {t('noVehiclesErrorModal:paragraph', { jatoId })}</Paragraph>
    </Modal>
  );
};
